import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  Step,
  Modal,
  Button,
  Header,
  Card,
} from "semantic-ui-react";
import TestataPagina from "../common/TestataPagina";
import { connect } from "react-redux";
import * as appActions from "../../redux/actions/appActions";
import * as cartActions from "../../redux/actions/cartActions";
import * as scuolaActions from "../../redux/actions/scuolaActions";
import * as scuolaNewActions from "../../redux/actions/scuolaNewActions";
import * as privateNewApi from "../../api/privateNewApi";
import PreferenzeLezioneForm from "./PreferenzeLezioneForm";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";

const PrivateNewMain = ({
  codScuola,
  lang,
  appData,
  datiScuola,
  loadSchoolData,
  loadSchoolDataNew,
  addPrivataNew,
  ...props
}) => {
  // State for dropdowns
  const [selectedSpecialita, setSelectedSpecialita] = useState(
    "5b343cc5-829b-4bbe-5c60-08ddcec0aab1"
  );
  const [selectedLivello, setSelectedLivello] = useState(
    "424dbaa2-4d31-4733-e5bc-08ddcec0aaaa"
  );
  const [selectedArea, setSelectedArea] = useState(
    "508eec57-a8e4-4d19-7165-08ddcec0aaa9"
  );
  const [numPupils, setNumPupils] = useState("2");
  const [selectedLang, setSelectedLang] = useState("0");
  const [datiAllievi, setDatiAllievi] = useState([
    { nome: "", cognome: "", livello: "-1", anno: "", sesso: "M" },
    { nome: "", cognome: "", livello: "-1", anno: "", sesso: "M" },
    { nome: "", cognome: "", livello: "-1", anno: "", sesso: "M" },
    { nome: "", cognome: "", livello: "-1", anno: "", sesso: "M" },
    { nome: "", cognome: "", livello: "-1", anno: "", sesso: "M" },
  ]);

  // State for step management
  const [currentStep, setCurrentStep] = useState(0);

  // State for Step 2 - Date and Time Selection
  const [startDate, setStartDate] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTimeRange, setSelectedTimeRange] = useState(null);
  const [availableDates, setAvailableDates] = useState([]);
  const [isLoadingTimeSlots, setIsLoadingTimeSlots] = useState(false);
  const [isLoadingAvailableDates, setIsLoadingAvailableDates] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);
  const [unavailableDates, setUnavailableDates] = useState([]);

  // State for Step 3 - Timeline selections
  const [dateTimelines, setDateTimelines] = useState({});
  const [isLoadingTimelines, setIsLoadingTimelines] = useState(false);
  const [maestroId, setMaestroId] = useState(null);

  // State for alternatives dialog
  const [showAlternativesDialog, setShowAlternativesDialog] = useState(false);
  const [alternatives, setAlternatives] = useState([]);

  useEffect(() => {
    if (codScuola && lang) {
      // Load new school data
      loadSchoolDataNew(codScuola, lang);
    }
  }, [codScuola, lang]);

  const { t } = useTranslation();

  const handleNext = () => {
    if (currentStep === 0) {
      if (
        selectedArea &&
        selectedSpecialita &&
        selectedLivello &&
        selectedLang
      ) {
        setIsLoadingAvailableDates(true);
        privateNewApi
          .getGiorniCompletamenteNonDisponibili(
            selectedArea,
            selectedSpecialita,
            selectedLivello,
            selectedLang
          )
          .then((dates) => {
            setUnavailableDates(dates);
            setIsLoadingAvailableDates(false);
            setCurrentStep(currentStep + 1);
          })
          .catch((error) => {
            console.error("Error fetching unavailable dates:", error);
            setIsLoadingAvailableDates(false);
          });
      }
    } else if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleFinish = () => {
    // Handle final step completion
    console.log("Process completed");
    addPrivataNew({ x: "data" }); // Example action, replace with actual data
  };

  // API call to get time slots for selected date
  const fetchTimeSlots = async (timeSlotData) => {
    setIsLoadingTimeSlots(true);
    try {
      // Set the time slots directly from the data passed from Step2Placeholder
      setTimeSlots(timeSlotData);
      setIsLoadingTimeSlots(false);
    } catch (error) {
      console.error("Error setting time slots:", error);
      setTimeSlots([]);
      setIsLoadingTimeSlots(false);
    }
  };

  // API call to get available dates for selected time range
  const fetchAvailableDates = async (timeRange) => {
    setIsLoadingAvailableDates(true);
    try {
      // Call the API to get non-selectable dates
      const response = await privateNewApi.getGiorniNonDisponibili(
        startDate,
        selectedArea,
        selectedSpecialita,
        selectedLivello,
        timeRange.start,
        timeRange.end
      );

      // Convert the response (array of non-selectable dates) to a list of available dates
      // For now, we'll use a placeholder implementation until we know the exact response format

      if (response && Array.isArray(response)) {
        // Assuming the API returns an array of non-selectable date strings in YYYY-MM-DD format

        // Generate a range of dates from startDate to startDate + 30 days
        const allDates = [];
        const start = new Date(startDate);
        const end = new Date(start);
        end.setDate(end.getDate() + 30); // 30 days range

        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
          const dateStr = d.toISOString().split("T")[0];
          allDates.push(dateStr);
        }

        // Filter out non-selectable dates
        const availableDatesArray = allDates.filter(
          (date) => !response.includes(date)
        );
        setAvailableDates(availableDatesArray);
      } else {
        // If response is not as expected, use placeholder data
        const placeholderDates = [
          "2025-01-15",
          "2025-01-16",
          "2025-01-17",
          "2025-01-20",
          "2025-01-21",
        ];
        setAvailableDates(placeholderDates);
      }

      setIsLoadingAvailableDates(false);
    } catch (error) {
      console.error("Error fetching available dates:", error);
      // Set some placeholder dates on error
      setAvailableDates([
        "2025-01-15",
        "2025-01-16",
        "2025-01-17",
        "2025-01-20",
        "2025-01-21",
      ]);
      setIsLoadingAvailableDates(false);
    }
  };

  // Helper function to check if GUID is empty
  const isEmptyGuid = (guid) => {
    return !guid || guid === "00000000-0000-0000-0000-000000000000";
  };

  // API call to get timeline data for each selected date in Step 3
  const fetchDateTimelines = async (customTimeRange = null) => {
    setIsLoadingTimelines(true);
    try {
      // Use custom time range if provided (from alternative selection), otherwise use selected time range
      const timeRange = customTimeRange || selectedTimeRange;

      // Prepare the data for the API call
      const primoGiorno = selectedDates[0].format("YYYY-MM-DD");
      const altriGiorniRichiesti = selectedDates
        .slice(1)
        .map((date) => date.format("YYYY-MM-DD"));

      // Call the API to get the best availability
      const response = await privateNewApi.getDisponibilitaMigliore(
        primoGiorno,
        timeRange.start,
        timeRange.end,
        selectedArea,
        selectedSpecialita,
        selectedLivello,
        altriGiorniRichiesti
      );

      // Check if maestroId is empty GUID
      if (isEmptyGuid(response.maestroId)) {
        // Show alternatives dialog if disponibilità contains alternatives
        if (
          response.disponibilità &&
          Array.isArray(response.disponibilità) &&
          response.disponibilità.length > 0
        ) {
          // Group alternatives by time range
          const alternativeTimeRanges = [];
          const timeRangeMap = new Map();

          response.disponibilità.forEach((slot) => {
            const key = `${slot.dalle}-${slot.alle}`;
            if (!timeRangeMap.has(key)) {
              timeRangeMap.set(key, {
                start: slot.dalle.slice(0, 5),
                end: slot.alle.slice(0, 5),
                dates: [],
              });
            }
            timeRangeMap.get(key).dates.push(slot.data);
          });

          setAlternatives(Array.from(timeRangeMap.values()));
          setShowAlternativesDialog(true);
          setIsLoadingTimelines(false);
          return;
        }
      }

      if (customTimeRange !== null) {
        setSelectedTimeRange(customTimeRange);
      }

      // Store the maestroId from the response
      setMaestroId(response.maestroId);

      // Transform the disponibilità into timeline format
      const timelines = {};
      if (response.disponibilità && Array.isArray(response.disponibilità)) {
        response.disponibilità.forEach((slot) => {
          const dateKey = slot.data;
          if (!timelines[dateKey]) {
            timelines[dateKey] = [];
          }
          timelines[dateKey].push({
            start: slot.dalle.slice(0, 5),
            end: slot.alle.slice(0, 5),
          });
        });
      }

      setDateTimelines(timelines);
      setIsLoadingTimelines(false);
    } catch (error) {
      console.error("Error fetching timelines:", error);
      setIsLoadingTimelines(false);
    }
  };

  // Handle alternative selection
  const handleAlternativeSelect = (alternative) => {
    setShowAlternativesDialog(false);
    setAlternatives([]);
    // Retry with the selected alternative time range

    fetchDateTimelines({
      start: alternative.start,
      end: alternative.end,
    });
  };

  // Handle alternative dialog cancellation
  const handleAlternativeCancel = () => {
    setShowAlternativesDialog(false);
    setAlternatives([]);
    setIsLoadingTimelines(false);
    // Optionally go back to previous step
    setCurrentStep(1);
  };

  // Fetch timelines when moving to Step 3
  useEffect(() => {
    if (
      currentStep === 2 &&
      selectedDates.length > 0 &&
      Object.keys(dateTimelines).length === 0
    ) {
      fetchDateTimelines();
    }
  }, [currentStep, selectedDates]);

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <PreferenzeLezioneForm
            datiScuola={datiScuola}
            selectedSpecialita={selectedSpecialita}
            selectedLivello={selectedLivello}
            selectedArea={selectedArea}
            setSelectedSpecialita={setSelectedSpecialita}
            setSelectedLivello={setSelectedLivello}
            setSelectedArea={setSelectedArea}
            onNext={handleNext}
            isLoading={props.loading}
            numPupils={numPupils}
            setNumPupils={setNumPupils}
            selectedLang={selectedLang}
            setSelectedLang={setSelectedLang}
          />
        );
      case 1:
        return (
          <Step2
            onNext={handleNext}
            onPrevious={handlePrevious}
            startDate={startDate}
            setStartDate={setStartDate}
            timeSlots={timeSlots}
            selectedTimeRange={selectedTimeRange}
            setSelectedTimeRange={setSelectedTimeRange}
            availableDates={availableDates}
            isLoadingTimeSlots={isLoadingTimeSlots}
            setIsLoadingTimeSlots={setIsLoadingTimeSlots}
            isLoadingAvailableDates={isLoadingAvailableDates}
            onDateSelect={fetchTimeSlots}
            onTimeRangeConfirm={fetchAvailableDates}
            selectedDates={selectedDates}
            setSelectedDates={setSelectedDates}
            selectedSpecialita={selectedSpecialita}
            selectedLivello={selectedLivello}
            selectedArea={selectedArea}
            codScuola={codScuola}
            unavailableDates={unavailableDates}
            startOrario={(datiScuola?.orarioDalle || "08:00").slice(0, 2)}
            endOrario={(datiScuola?.orarioAlle || "18:00").slice(0, 2)}
          />
        );
      case 2:
        return (
          <Step3
            onPrevious={handlePrevious}
            onNext={handleNext}
            selectedDates={selectedDates}
            selectedTimeRange={selectedTimeRange}
            dateTimelines={dateTimelines}
            isLoadingTimelines={isLoadingTimelines}
            numPupils={numPupils}
            startOrario={(datiScuola?.orarioDalle || "08:00").slice(0, 2)}
            endOrario={(datiScuola?.orarioAlle || "18:00").slice(0, 2)}
          />
        );
      case 3:
        return (
          <Step4
            onPrevious={handlePrevious}
            onFinish={handleFinish}
            numPupils={numPupils}
            datiAllievi={datiAllievi}
            setDatiAllievi={setDatiAllievi}
            livelli={datiScuola?.livelli || []}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container>
      <div className="head-offset"></div>
      <TestataPagina
        titolo={t("lezioni_private")}
        icon="user"
        sottoTitolo={t("scegli_preferenze_private")}
      />

      <Step.Group attached="top" widths={4}>
        <Step active={currentStep === 0} completed={currentStep > 0}>
          <Step.Content>
            <Step.Title>Preferenze Lezione</Step.Title>
            <Step.Description>
              Scegli specialità, livello e area
            </Step.Description>
          </Step.Content>
        </Step>
        <Step active={currentStep === 1} completed={currentStep > 1}>
          <Step.Content>
            <Step.Title>Date e orari</Step.Title>
            <Step.Description>Scegli le date e gli orari</Step.Description>
          </Step.Content>
        </Step>
        <Step active={currentStep === 2} completed={currentStep > 2}>
          <Step.Content>
            <Step.Title>Programma</Step.Title>
            <Step.Description>Definisci il programma</Step.Description>
          </Step.Content>
        </Step>
        <Step active={currentStep === 3} completed={currentStep > 3}>
          <Step.Content>
            <Step.Title>Allievi</Step.Title>
            <Step.Description>Informazioni allievi</Step.Description>
          </Step.Content>
        </Step>
      </Step.Group>

      {renderStepContent()}

      {/* Alternatives Dialog */}
      <Modal open={showAlternativesDialog} size="small">
        <Header
          icon="clock"
          content={
            t("alternative_times_available") || "Alternative orari disponibili"
          }
        />
        <Modal.Content>
          <p>
            {t("no_instructor_available_message") ||
              "Non è disponibile un maestro per l'orario selezionato. Scegli uno degli orari alternativi:"}
          </p>
          <Card.Group>
            {alternatives.map((alternative, index) => (
              <Card
                key={index}
                onClick={() => handleAlternativeSelect(alternative)}
                style={{ cursor: "pointer" }}
              >
                <Card.Content>
                  <Card.Header>
                    {alternative.start} - {alternative.end}
                  </Card.Header>
                  <Card.Description>
                    {t("available_on_dates") || "Disponibile per"}:{" "}
                    {alternative.dates.join(", ")}
                  </Card.Description>
                </Card.Content>
              </Card>
            ))}
          </Card.Group>
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={handleAlternativeCancel}>
            {t("cancel") || "Annulla"}
          </Button>
        </Modal.Actions>
      </Modal>
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    codScuola: ownProps.match.params.slug,
    lang: ownProps.match.params.lang,
    datiScuola: state.scuolaNewReducer,
    loading: state.apiCallsInProgress > 0,
  };
}

const mapDispatchToProps = {
  setLang: appActions.setLang,
  setSlug: appActions.setSlug,
  clearAppData: appActions.clearAppData,
  loadSchoolData: scuolaActions.loadSchoolData,
  loadSchoolDataNew: scuolaNewActions.loadSchoolDataNew,
  addPrivataNew: cartActions.addPrivataNew,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateNewMain);
